import moment from "moment";

/** Characters not allowed in Sample Details input */
export const INVALID_CHARS = ["/u2022"];

export const COMPOSITE_FIELD_DELIMITER = "_:_";

/** Regex special chars are escaped i.e. "\\(", "\\)" */
export const INVALID_CHARS_ESCAPED = [
  " \\(Replicate-[\\d]+\\)",
  "\u{2022}",
  COMPOSITE_FIELD_DELIMITER,
  "_:",
  ":_",
];
/** json fields that stand for product name */
export const PRODUCT_NAME_FIELDS_SET = new Set(["name", "description"]);

/** Character limits for certain fields */
export const CHAR_LIMITS = {
  sample_id: 2000,
  analysis_request_search: 100,
  po: 200,
  comment: 500,
  sample_type: 100,
  submission_name: 200,
};

/**
 * Build a generic validator based on a backend-provided format string,
 * using Moment.js strict parsing instead of custom regex.
 *
 * Backend tokens:
 * - Date: yyyy, yy, mm, dd
 * - Time: hh, mm, ss
 *
 * @param {string} format backend format string, e.g. "mm/dd/yyyy", "hh:mm"
 * @param {"date" | "time"} type field type
 * @returns {{ validate: (value: string) => { isValid: boolean, errorMessage: string | null }, placeholder: string }}
 */
export const buildFieldFormatValidator = (format, type) => {
  if (!format) {
    return {
      validate: () => ({ isValid: true, errorMessage: null }),
      placeholder: "",
    };
  }

  let momentFormat = format;

  // Map backend tokens to Moment tokens
  if (type === "date") {
    momentFormat = momentFormat
      .replace(/yyyy/gi, "YYYY")
      .replace(/yy/gi, "YY")
      .replace(/mm/gi, "MM")
      .replace(/dd/gi, "DD");
  } else if (type === "time") {
    momentFormat = momentFormat
      .replace(/hh/gi, "HH")
      .replace(/mm/gi, "mm")
      .replace(/ss/gi, "ss");
  } else {
    momentFormat = momentFormat
      .replace(/yyyy/gi, "YYYY")
      .replace(/yy/gi, "YY")
      .replace(/dd/gi, "DD")
      .replace(/hh/gi, "HH");
  }

  const errorMessage = `Please enter value in ${format} format`;

  const validate = (value) => {
    if (!value || value.trim() === "") {
      return { isValid: true, errorMessage: null };
    }

    const trimmed = value.trim();
    const isValid = moment(trimmed, momentFormat, true).isValid();

    return {
      isValid,
      errorMessage: isValid ? null : errorMessage,
    };
  };

  return {
    validate,
    placeholder: format,
  };
};

/**
 * Finds all matches, keeps track of lastIndex.
 * Any subsequent tests on the same string will start from lastIndex and might give "wrong" result
 * Use with match or replace (when you want all matches, this is slower than test)
 */
export const replicateTagRegexGlobal = new RegExp(/ *\(Replicate-[\d]+\)/, "g"); // looks for "(Replicate-#)" with any number of spaces before

/**
 * Finds first match, use with test, will return the same value every time
 */
export const replicateTagRegexFirstMatch = new RegExp(/ *\(Replicate-[\d]+\)/); // looks for "(Replicate-#)" with any number of spaces before
